import React, { useCallback, useEffect } from 'react';
import { fromJS } from 'immutable';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import useActions from './useActions';
import { TEMPLATE_TABS } from 'components/Pages/Template/contants';
import { VIEW_REPORT_TYPES } from 'constants/common';
import moment from 'moment';

const withFilter =
  ({ filterKey }) =>
    (WrappedComponent) => {
      const WithFilter = (props) => {
        const filters = useSelector(selectFiltersByKey(filterKey));
        const setFiltersFieldByKeyAction = useActions(setFiltersFieldByKey);

        useEffect(() => {
          if (!filters) {
            setFiltersFieldByKeyAction(filterKey, {
              ...DEFAULT_FILTER[filterKey],
            });
          }
        }, []);

        const setFiltersFieldAction = useCallback(
          (values) => {
            setFiltersFieldByKeyAction(filterKey, values);
          },
          [filterKey]
        );

        const _onChangePagination = useCallback(
          (data) => {
            const { current, ...rest } = data;
            setFiltersFieldAction({
              ...filters,
              page: current,
              ...rest,
            });
          },
          [filters, setFiltersFieldAction]
        );

        return (
          <WrappedComponent
            {...props}
            filterKey={filterKey}
            filters={filters || {}}
            setFiltersFieldAction={setFiltersFieldAction}
            onChangePagination={_onChangePagination}
          />
        );
      };
      return WithFilter;
    };

export default withFilter;

export const filterName = 'FILTER';
const FILTER_SET_FILTER_FIELD_BY_KEY =
  `${filterName}_` + 'SET_FILTER_FIELD_BY_KEY';

//Actions
export const setFiltersFieldByKey = (key, payload) => {
  return {
    type: FILTER_SET_FILTER_FIELD_BY_KEY,
    key,
    payload,
  };
};

//Reducer
export const filterRd = (state = fromJS({}), action) => {
  const { type, payload, key } = action;
  switch (type) {
    case FILTER_SET_FILTER_FIELD_BY_KEY: {
      return state.set(key, payload);
    }
    default:
      return state;
  }
};

//Selectors
const getFilterState = (state) => state[filterName];
export const selectFiltersByKey = (key) =>
  createSelector(getFilterState, (state) => state.getIn([key]));

export const defaultFilter = { skip: 0, take: 10, page: 1, terms: '' };

export const FILTER_KEY = {
  TEMPLATE_LIST: 'TEMPLATE_LIST',
  PURCHASE_HISTORY: 'PURCHASE_HISTORY',
  VIEW_REPORT: 'VIEW_REPORT',
  CAMPAIGN_LIST: 'CAMPAIGN_LIST',
  CODE_LIST: 'CODE_LIST',
  ALLOCATION_LIST: 'ALLOCATION_LIST',
  PARTNER_PROGRAM_LIST: 'PARTNER_PROGRAM_LIST',
  DIVIDEND_PAYOUTS_LIST: 'DIVIDEND_PAYOUTS_LIST',
};

export const DEFAULT_FILTER = {
  [FILTER_KEY.TEMPLATE_LIST]: {
    ...defaultFilter,
    tab: TEMPLATE_TABS.ALL,
    type: undefined,
  },
  [FILTER_KEY.PURCHASE_HISTORY]: {
    ...defaultFilter,
    tab: TEMPLATE_TABS.PURCHASE_HISTORY,
  },
  [FILTER_KEY.VIEW_REPORT]: {
    ...defaultFilter,
    type: VIEW_REPORT_TYPES.DATE,
    startDate: moment().subtract(7, 'days'),
    endDate: moment(),
  },
  [FILTER_KEY.CAMPAIGN_LIST]: {
    ...defaultFilter,
  },
  [FILTER_KEY.CODE_LIST]: {
    ...defaultFilter,
    name: '',
    startDate: '',
    expiredDate: '',
    status: '',
    type: '',
  },
  [FILTER_KEY.PARTNER_PROGRAM_LIST]: {
    ...defaultFilter,
  },
  [FILTER_KEY.DIVIDEND_PAYOUTS_LIST]: {
    ...defaultFilter,
  },
};
